import type { ConfigurationSetup } from './config/config-setup.types';
import { TeoWritableStore } from './state/TeoStore';
import type { PromptOptionTemplate } from './TeoApi';

export type DynamicConfigOptions = {
  alwaysCheckBrandFit: boolean;
  evaluationProfileId: number;
  subscriptionName: string;
  textConfigOptions: ConfigurationSetup | null;
  useExpParser: boolean;

  // --- Flags ---
  brandFitEnabled: boolean;
  textGeneratorEnabled: boolean;
  whitelistEnabled: boolean;
  dictionaryEnabled: boolean;
  plainLanguageEnabled: boolean;
  promptOptionTemplates: PromptOptionTemplate[] | null;
};

export class DynamicConfigStore extends TeoWritableStore<DynamicConfigOptions> {
  constructor(options: Partial<DynamicConfigOptions> = {}) {
    super({
      alwaysCheckBrandFit: false,
      evaluationProfileId: 3,
      subscriptionName: '',
      textConfigOptions: null,
      useExpParser: false,
      // Flags
      brandFitEnabled: false,
      textGeneratorEnabled: false,
      whitelistEnabled: true,
      dictionaryEnabled: true,
      plainLanguageEnabled: true,
      promptOptionTemplates: null,
      ...options,
    });
  }

  get options() {
    return this.state;
  }

  getTemplateById(id: Maybe<string>): PromptOptionTemplate | null {
    if (!id) return null;
    return this.state.promptOptionTemplates?.find((t) => t.id === id) ?? null;
  }
}
